// --- Core ---
import {ReactElement} from "react";
import {FormattedMessage} from "react-intl";
// --- Material UI ---
import {CircularProgress, DialogContent, Stack, StackProps, Typography, TypographyProps} from "@mui/material";
// --- SaniQ ---
import {DialogTitle} from "helpers/Dialog";

const DialogLoading = ({onClose: handleClose, title}) => (
  <>
    <DialogTitle onClose={handleClose} title={title}/>
    <DialogContent>
      <Loading/>
    </DialogContent>
  </>
);

interface LoadingProps {
  title?: string | ReactElement;
  variant?: TypographyProps["variant"];
}

/**
 * Loading display
 *
 * Shows a big loading circle with a title.
 */
export default function Loading({variant = "h5", title = <FormattedMessage id="loading" defaultMessage="Loading..."/>}: Readonly<LoadingProps>) {
  return (
    <Stack
      spacing={4}
      sx={
        {
          alignItems: "center",
          justifyContent: "center",
          flexGrow: 1
        }
      }
    >
      <CircularProgress size={40} thickness={5}/>
      <Typography variant={variant}>
        {title}
      </Typography>
    </Stack>
  );
}

interface SmallLoadingProps {
  direction?: StackProps["direction"];
  variant?: TypographyProps["variant"];
  title?: ReactElement;
}

const SmallLoading = (
  {
    direction = "row",
    variant = "body1",
    title = <FormattedMessage id="loading" defaultMessage="Loading..."/>
  }: SmallLoadingProps
) => (
  <Stack
    direction={direction}
    spacing={2}
    sx={
      {
        alignItems: "center",
        justifyContent: "center",
        m: 2
      }
    }
  >
    <CircularProgress size={24} thickness={6}/>
    <Typography variant={variant}>
      {title}
    </Typography>
  </Stack>
);

export {
  DialogLoading,
  Loading,
  SmallLoading
};
